import { reactQueryMutationAdapter } from "@dashboardApi/apis/reactQueryFetcherAdapters";

import fetch from "@lib/fetch";

import { apiUsageAlertUpsertCacheKeys } from "./constants";
import type { PostApiUsageAlertUpsertProps } from "./types";

export const postApiUsageAlertUpsert = reactQueryMutationAdapter(
  apiUsageAlertUpsertCacheKeys,
  (props: PostApiUsageAlertUpsertProps): Promise<void> => {
    return fetch("/api_usage_alert/upsert", "POST", props, undefined, { propagateFetchRequestError: false });
  }
);

export const deleteApiUsageAlert = reactQueryMutationAdapter(
  apiUsageAlertUpsertCacheKeys,
  (props: { alertId: string }): Promise<void> => {
    return fetch(`/api_usage_alert/${props.alertId}`, "DELETE", {}, undefined, {});
  }
);
